import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthOIDCService } from '../auth/authOIDC.service';
import { BaseService } from './base.service';

declare var jquery: any;
declare var $: any;

@Injectable()
export class Util {

    constructor( 
        private bs: BaseService,
        private authOIDCService: AuthOIDCService
    ) {
        this.bs.log('info', 'Loaded Class Util');
    }

    checkNetworkInfo() {
        const networkState = navigator['connection'].type;
        console.log('networkState', networkState);
        if (networkState == 'none') {
            return false;
        } else {
            return true;
        }
    }

    disable(id: string) {
        $('#' + id).css('pointer-events', 'none');
    }

    enable(id: string) {
        $('#' + id).css('pointer-events', 'auto');
    }

    toaster (message:any) {
        /*To be done 
        as this is to be cenral point for displaying messages*/
        /*const $item = $('<div/>', {
            'html': message,
            'class': 'toaster'
        });

        $item.appendTo($('[data-role=page]')).fadeIn('slow');

        setTimeout(function () {
            $item.fadeOut('slow');
            $item.remove();
        }, 2000);*/

    }

    progressBar (message: string) {
        const $item = $('<div/>', {
            'html': message,
            'class': 'toaster',
            'id': 'progressBar'
        });
        $item.appendTo($('[data-role=page]')).fadeIn('slow');
    }

    updateProgressBar(msg: string) {
        $('#progressBar').html(msg);
    }

    hideProgressBar(){
        $('#progressBar').remove();
    }

    showLoader() {
        this.disable('content');
        //$.mobile.loading( 'show' );
    }

    hideLoader() {
        this.enable('content');
        //$.mobile.loading( 'hide' );
    }

    uploadFile(fileURI: any, allowFileType:any, uploadMethod: string) {
        console.log(fileURI);
        this.showLoader();
        const formData: FormData = new FormData();
        formData.append('uploadFile', fileURI, fileURI['name']);
        formData.append('CorporateID', this.bs.user['CorporateId']);
        formData.append('Culture', this.bs.user['Culture']);
        formData.append('userId', this.bs.user['UserId']);
        formData.append('AllowFileType', allowFileType);
        return Observable.create( (observer:any) => {
            const xhr: XMLHttpRequest = new XMLHttpRequest();
            xhr.open('POST', this.bs.config.apiEndpoint + uploadMethod, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.authOIDCService.token);
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        observer.next(JSON.parse(xhr.response));
                        this.hideLoader();
                        observer.complete();
                    } else {
                        this.hideLoader();
                        observer.error(xhr.response);
                    }
                }
            };

            xhr.upload.onprogress = (event) => {
                const progress = Math.round(event.loaded / event.total * 100);
                observer.next(progress);
            };
            xhr.send(formData);
        });
    }

    getScripts(scripts:any) {
        return new Promise((resolve, reject) => {
            let progress = 0;
            scripts.forEach(function(script:any) {
                $.getScript( script ).done( function( script1:any, textStatus:any ) {
                    console.log( textStatus );
                    if (++progress == scripts.length) {
                        resolve({});
                    }
                }).fail(function( jqxhr:any, settings:any, exception:any ) {
                    console.log( jqxhr, settings, exception );
                    reject();
                });
            });
        });
    }

    generateRandomString(){
        return Math.random().toString(36).substring(2);
    }

    escape(string:any){
        return (string + '').replace(/[&<>"'/]/g, '\\$&');
    }
}

